module.exports = __webpack_public_path__ + "static/gallery3-3c5fb82a660917220706b0df8b533d31.jpg";